// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB6tdjW7zDL2eBDfE2KVCXX_aDLhYSAo1U",
  authDomain: "videozz-69160.firebaseapp.com",
  projectId: "videozz-69160",
  storageBucket: "videozz-69160.firebasestorage.app",
  messagingSenderId: "311392510742",
  appId: "1:311392510742:web:d8136a719628b710cfe637",
  measurementId: "G-R9807LXXQJ",
  database:'https://videozz-69160-default-rtdb.firebaseio.com/'
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
